import { createTheme, responsiveFontSizes } from "@mui/material";

let husibuechThemeDark = createTheme({
  KsbItAppBar: {
    "&:hover": {
      backgroundColor: "green",
    },
  },

  palette: {
    mode: "dark", // ✅ FIXED

    primary: {
      main: "#38679c",
      light: "#6b95cd",
      dark: "#003d6d",
    },

    secondary: {
      main: "#38999c",
      light: "#6ecacd",
      dark: "#006a6e",
    },

    tertiary: {
      main: "#f44336",
      light: "#ff7961",
      dark: "#ba000d",
    },

    background: {
      default: "#121212",
      paper: "#1A2027",
      special: "#e8f5e9",
      red: "#e53935",
      error: "#e53935",
      success: "#389c6d",
      black: "#111111",
      specialBlack: "#333333",
    },

    levels: {
      green: "#2e7d32",
      lightGreen: "#c0ca33",
      yellow: "#fdd835",
      orange: "#fb8c00",
      red: "#e53935",
      purple: "#ab47bc",
      lightPurple: "#bc47b6",
      blue: "#38679c",
      lightBlue: "#add8e6",
      white: "#FFFFFF",
      primary: "#FFFFFF",
      secondary: "#38679c",
    },

    text: {
      primary: "#FFFFFF",
      secondary: "#38679c",
      inactive: "rgba(255,255,255,0.6)",
      green: "#2e7d32",
      lightGreen: "#c0ca33",
      yellow: "#fdd835",
      orange: "#fb8c00",
      red: "#e53935",
      purple: "#ab47bc",
      lightPurple: "#bc47b6",
      blue: "#38679c",
      lightBlue: "#add8e6",
      white: "#FFFFFF",
    },

    icon: {
      primary: "#38679c",
      secondary: "#7bb4da",
    },

    success: {
      main: "#389c6d",
    },
    info: {
      main: "#3b389c",
    },
    error: {
      main: "#9c3b38",
      light: "#c2605c",
      dark: "#7a2e2c",
      contrastText: "#FFFFFF",
    },
    warning: {
      main: "#9c3899",
    },

    eventManager: {
      slot: {
        mine: "#4C7ED9",
        reserved: "#4CAF50",
        free: "#6B7280",
      },
      textOnSlot: "#FFFFFF",
    },
  },

  breakpoints: {
    values: {
      xss: 200,
      xs: 400,
      ss: 600,
      sm: 800,
      mds: 960,
      md: 1000,
      lg: 1400,
      xl: 1800,
      xxl: 2200,
      xxxl: 2600,
    },
  },

  typography: {
    fontFamily: "Oswald",
    fontSize: 14,

    h1: { fontSize: "3rem", lineHeight: 1.25, fontWeight: 400 },
    h2: { fontSize: "2.5rem", lineHeight: 1.25, fontWeight: 400 },
    h3: { fontSize: "2rem", lineHeight: 1.25, fontWeight: 600 },
    h4: { fontSize: "2rem", lineHeight: 1.25, fontWeight: 400 },
    h5: { fontSize: "1.5rem", fontWeight: 600, lineHeight: 1.25 },
    h6: { fontSize: "1.5rem", fontWeight: 400, lineHeight: 1.25 },

    subtitle1: { fontSize: "1.2rem", fontWeight: 500 },
    subtitle2: { fontSize: "1.2rem", fontWeight: 400 },

    body1: { fontSize: "1rem", lineHeight: 1.2 },
    body2: { fontSize: "1rem", lineHeight: 1.2 },

    button: {
      fontWeight: 500,
      lineHeight: 1.5,
    },
  },

  spacing: 8,

  // ✅ modern MUI v5 replacement
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          fontSize: 10,
        },
      },
      defaultProps: {
        color: "primary",
      },
    },

    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 42,
          height: 26,
          padding: 0,
          margin: 8,
        },
        thumb: {
          width: 24,
          height: 24,
        },
        track: {
          borderRadius: 13,
        },
      },
    },

    MuiButton: {
      defaultProps: { size: "small" },
    },
    MuiButtonGroup: {
      defaultProps: { size: "small" },
    },
    MuiCheckbox: {
      defaultProps: { size: "small" },
    },
    MuiTextField: {
      defaultProps: { size: "small", margin: "dense" },
    },
    MuiTooltip: {
      defaultProps: { arrow: true },
    },
    MuiList: {
      defaultProps: { dense: true },
    },
    MuiMenuItem: {
      defaultProps: { dense: true },
    },
    MuiTable: {
      defaultProps: { size: "small" },
    },
  },

  shape: {
    borderRadius: 4,
  },
});

husibuechThemeDark = responsiveFontSizes(husibuechThemeDark, {
  breakpoints: ["xs", "sm", "md", "lg", "xl"],
  factor: 3,
});

export default husibuechThemeDark;
